var _class, _temp2;

var _templateObject = _taggedTemplateLiteralLoose(["padding: 1.25em 2em"], ["padding: 1.25em 2em"]),
    _templateObject2 = _taggedTemplateLiteralLoose(["\n    padding: 1.25em 0em;\n    & > div {\n      width: ", ";\n    }\n  "], ["\n    padding: 1.25em 0em;\n    & > div {\n      width: ", ";\n    }\n  "]),
    _templateObject3 = _taggedTemplateLiteralLoose(["display: none"], ["display: none"]);

function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled, { css, ThemeProvider, withTheme } from "styled-components";
import Logo from "./Logo";
import Link from "./Link";
import Button, { ButtonScreen } from "./Button";
import ToggleMenuIcon from "../icons/ToggleMenuIcon";
import ScrollEvent from "./ScrollEvent";
import { media, Responsive, defaultTheme } from "../index";

var MobileToggleButton = styled.a.withConfig({
  displayName: "Menu__MobileToggleButton",
  componentId: "sc-1fggkpt-0"
})(["&&{color:", ";}"], function (props) {
  return props.theme.textStrong;
});
var AlignBaseLine = styled.div.withConfig({
  displayName: "Menu__AlignBaseLine",
  componentId: "sc-1fggkpt-1"
})(["display:flex;align-items:baseline;"]);

var Menu = (_temp2 = _class = function (_React$Component) {
  _inherits(Menu, _React$Component);

  function Menu() {
    var _temp, _this, _ret;

    _classCallCheck(this, Menu);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      fixed: false,
      mobileNavOpen: false
    }, _this.toggleMobileNav = function () {
      _this.setState(function (prev) {
        var open = !prev.mobileNavOpen;
        if (open) _this.props.onOpen();
        return { mobileNavOpen: open };
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Menu.prototype.render = function render() {
    var _this2 = this;

    var theme = this.props.theme;


    var logoText = theme && theme.logoText;
    var logoBackground = theme && theme.logoBackground;

    var menuLogo = this.props.logoWrapper ? React.createElement(this.props.logoWrapper, {}, React.createElement(Logo, { color: logoText, background: logoBackground })) : React.createElement(Logo, { color: logoText, background: logoBackground });

    /**
     * Constructs menu component from given desktop- and mobileContent
     * both used for the fixed and static menu
     * @param {*} content  Desktop content the menu should show
     * @param {*} fixedMobileContent  Mobile content the menu should show fixed in the bar
     */
    var menuNavigation = function menuNavigation(content, fixedMobileContent) {
      return React.createElement(
        MenuNavigation,
        null,
        React.createElement(
          Responsive,
          { show: "desktop" },
          React.createElement(
            AlignBaseLine,
            null,
            content || _this2.props.children
          )
        ),
        React.createElement(
          Responsive,
          { hide: "desktop" },
          fixedMobileContent,
          _this2.props.mobileContent && React.createElement(
            MobileToggleButton,
            {
              onClick: _this2.toggleMobileNav,
              toggled: _this2.state.mobileNavOpen,
              inverted: _this2.props.inverted,
              fixed: _this2.state.fixed,
              custom: _this2.props.customToggleColor
            },
            React.createElement(ToggleMenuIcon, { toggle: _this2.state.mobileNavOpen })
          )
        )
      );
    };

    var showFixed = this.state.fixed || this.state.mobileNavOpen;

    var menuContent = menuNavigation(this.props.staticContent);

    // Fall back to regular content if there is not changed fixed content
    var menuFixedContent = menuNavigation(this.props.fixedContent || this.props.staticContent, this.props.fixedMobileContent);

    return React.createElement(
      Fragment,
      null,
      React.createElement(ScrollEvent, {
        offset: 150,
        onPass: function onPass() {
          return _this2.setState({ fixed: true });
        },
        onReverse: function onReverse() {
          return _this2.setState({ fixed: false });
        }
      }),
      React.createElement(
        MenuBarStatic,
        {
          positionAbsolute: this.props.positionAbsolute,
          inverted: this.props.inverted
        },
        React.createElement(
          "div",
          null,
          menuLogo,
          menuContent
        )
      ),
      React.createElement(
        MenuBarFixed,
        { className: showFixed && "visible" },
        menuLogo,
        React.createElement(
          ThemeProvider,
          { theme: defaultTheme },
          menuFixedContent
        )
      ),
      React.createElement(MenuMobileDimmer, {
        visible: this.state.mobileNavOpen,
        onClick: this.toggleMobileNav
      }),
      React.createElement(
        MenuMobileNavigation,
        { visible: this.state.mobileNavOpen },
        React.createElement(
          ThemeProvider,
          { theme: defaultTheme },
          this.props.mobileContent || this.props.children
        )
      )
    );
  };

  return Menu;
}(React.Component), _class.defaultProps = {
  onOpen: function onOpen() {}
}, _temp2);
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  logoWrapper: PropTypes.func,
  staticContent: PropTypes.node,
  fixedContent: PropTypes.node,
  fixedMobileContent: PropTypes.node,
  mobileContent: PropTypes.node,
  customToggleColor: PropTypes.string,
  inverted: PropTypes.bool,
  onOpen: PropTypes.func,
  positionAbsolute: PropTypes.bool
} : {};


var MenuBar = styled.header.withConfig({
  displayName: "Menu__MenuBar",
  componentId: "sc-1fggkpt-2"
})(["box-sizing:border-box;display:flex;width:100%;padding:1.25em;z-index:998;", ";", "{position:absolute;top:1em;width:90px;}a,", "{", ";}"], media.desktop(_templateObject), Logo, Link, function (props) {
  return props.inverted && css(["color:white !important;"]);
});

var MenuBarStatic = styled(MenuBar).withConfig({
  displayName: "Menu__MenuBarStatic",
  componentId: "sc-1fggkpt-3"
})(["background:transparent;height:120px;width:100%;& > div{width:100%;display:flex;margin:0 auto;justify-content:space-between;}", ";", ";"], media.wide(_templateObject2, function (props) {
  return props.theme.width;
}), function (props) {
  return props.positionAbsolute && css(["position:absolute;"]);
});

// For some mysterious reason the "visible" state cannot be set as a prop.
// Safari sometimes messes up other elements if all styling is reapplied.
var MenuBarFixed = styled(MenuBar).withConfig({
  displayName: "Menu__MenuBarFixed",
  componentId: "sc-1fggkpt-4"
})(["position:fixed;top:0;height:3.5em;background:rgba(255,255,255,0.9);border-bottom:1px solid #e1e1e1;z-index:1000;visibility:hidden;transform:translateY(-150%);transition:transform 0.25s;&.visible{visibility:visible;transform:translateY(0);}", "{top:0;width:64px;}", "{width:auto;margin-top:-0.5em;vertical-align:middle;", "{padding:0.5em 1em !important;}}"], Logo, Button, ButtonScreen);

var MenuNavigation = styled.nav.withConfig({
  displayName: "Menu__MenuNavigation",
  componentId: "sc-1fggkpt-5"
})(["margin-left:auto;line-height:1em;font-size:1em;a,", "{display:inline-block;cursor:pointer;padding-bottom:1.25em;padding-left:1em;padding-right:1em;&:last-child{padding-right:0;}", ";}", "{margin-left:1em;}"], Link, function (props) {
  return props.inverted && css(["color:white;"]);
}, Button);

var MenuMobileDimmer = styled.div.withConfig({
  displayName: "Menu__MenuMobileDimmer",
  componentId: "sc-1fggkpt-6"
})(["", ";position:fixed;top:0;bottom:", ";left:0;right:0;background:rgba(0,0,0,0.5);z-index:900;opacity:", ";pointer-events:", ";transition:opacity 0.25s;"], media.desktop(_templateObject3), function (props) {
  return props.visible ? 0 : "100%";
}, function (props) {
  return props.visible ? 1 : 0;
}, function (props) {
  return props.visible ? "auto" : "none";
});

var MenuMobileNavigation = styled.nav.withConfig({
  displayName: "Menu__MenuMobileNavigation",
  componentId: "sc-1fggkpt-7"
})(["", ";position:fixed;top:0;left:0;right:0;padding:2em;margin-top:3em;z-index:999;transform:translateY(", ");opacity:", ";transition:all 0.25s;", "{display:block;padding:1em 0;&:not(:last-child){border-bottom:1px solid #f4f4f4;}&:hover{color:", ";&:before{display:none;}}}&:before{content:\"\";position:absolute;height:200%;top:-100%;right:0;bottom:0;left:0;background:white;transform:skewY(-18deg) translateY(5vw);}"], media.desktop(_templateObject3), function (props) {
  return props.visible ? 0 : "-150%";
}, function (props) {
  return props.visible ? 1 : 0;
}, Link, function (props) {
  return props.theme.secondary;
});

export default withTheme(Menu);